module.exports = __webpack_public_path__ + "static/media/landing_img_2.a15572ad.png";